import { render, staticRenderFns } from "./AdminProviderOfferItem.vue?vue&type=template&id=105e96c6&"
import script from "./AdminProviderOfferItem.vue?vue&type=script&lang=ts&"
export * from "./AdminProviderOfferItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports